import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import { HiOutlineMail, HiOutlinePhone } from "react-icons/hi";

import {
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: "Home", path: "/" },
    { name: "About us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Products", path: "/products" },
    { name: "Contact us", path: "/contact" },
  ];

  return (
    <>
      {/* Top Bar */}
      <div className="hidden lg:block bg-slate-900 text-gray-300 text-sm">
        <div className="max-w-7xl mx-auto px-6 py-2 flex justify-between items-center">
          {/* Contact Info */}
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-2">
              <HiOutlineMail />
              info@bytecstechnologies.com
            </span>

            <span className="flex items-center gap-2">
              <HiOutlinePhone />
              +91 9834587366
            </span>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <span className="mr-1 text-white-500">Follow Us:</span>

            <a
              href="https://www.linkedin.com/company/bytecstechnologies/?originalSubdomain=in"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full bg-slate-800 hover:bg-blue-600 flex items-center justify-center transition duration-300"
            >
              <FaLinkedinIn size={14} />
            </a>

            <a
              href="https://www.youtube.com/embed/FC8zG-OcH7A"
              target="_blank"
              class="w-8 h-8 rounded-full bg-slate-800 hover:bg-red-600 flex items-center justify-center transition duration-300"
            >
              <FaYoutube size={14} />
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="sticky top-0 z-50 backdrop-blur-md bg-white/95 border-b border-gray-100 shadow-lg">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/logo.png"
                alt="Bytecs Technologies"
                className="h-14 w-auto"
              />
            </Link>

            {/* Desktop Menu */}
            <nav className="hidden md:flex items-center gap-8">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === "/"}
                  className={({ isActive }) =>
                    `relative font-semibold transition-all duration-300 ${
                      isActive
                        ? "text-[#18A9D5]"
                        : "text-slate-700 hover:text-[#18A9D5]"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {item.name}

                      <span
                        className={`absolute  bg-lightblue-600 transition-all duration-300 ${
                          isActive ? "w-full" : "w-0"
                        }`}
                      ></span>
                    </>
                  )}
                </NavLink>
              ))}

              <Link
                to="/contact"
                className="bg-[#18A9D5] from-blue-600 to-indigo-600 text-white px-6 py-3 rounded-xl font-medium shadow-lg hover:scale-105 transition"
              >
                Let`s Talk
              </Link>
            </nav>

            {/* Mobile Button */}
            <button
              className="md:hidden text-3xl text-slate-700"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <HiX /> : <HiMenu />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isOpen && (
            <div className="md:hidden border-t py-4 bg-white">
              <div className="flex flex-col gap-3">
                {navItems.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    end={item.path === "/"}
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) =>
                      `px-4 py-3 rounded-lg font-medium ${
                        isActive ? "bg-blue-50 text-blue-600" : "text-slate-700"
                      }`
                    }
                  >
                    {item.name}
                  </NavLink>
                ))}

                <Link
                  to="/contact"
                  className="bg-blue-600 text-center text-white py-3 rounded-lg"
                >
                  Get Quote
                </Link>
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
